__turbopack_context__.v({
  "body": "FullscreenChartModal-module__8HmFSW__body",
  "closeButton": "FullscreenChartModal-module__8HmFSW__closeButton",
  "content": "FullscreenChartModal-module__8HmFSW__content",
  "description": "FullscreenChartModal-module__8HmFSW__description",
  "header": "FullscreenChartModal-module__8HmFSW__header",
  "headerActions": "FullscreenChartModal-module__8HmFSW__headerActions",
  "overlay": "FullscreenChartModal-module__8HmFSW__overlay",
  "resetButton": "FullscreenChartModal-module__8HmFSW__resetButton",
  "title": "FullscreenChartModal-module__8HmFSW__title",
});
